/** The historical client-side allowlist (mp4/jpg/png/pdf). Preserved as the
 *  default so existing callers are unchanged. */
export const DEFAULT_UPLOAD_MIME_TYPES = [
  'video/mp4',
  'image/jpeg',
  'image/png',
  'application/pdf',
] as const;

/** Image types accepted for media layers (phase 1). */
export const LAYER_IMAGE_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
] as const;

/** Video types accepted for media layers. */
export const LAYER_VIDEO_MIME_TYPES = [
  'video/mp4',
  'video/webm',
  'video/quicktime',
] as const;

/** Audio types accepted for media layers. */
export const LAYER_AUDIO_MIME_TYPES = [
  'audio/mpeg',
  'audio/wav',
  'audio/mp4',
  'audio/ogg',
] as const;

export function isAcceptedMimeType(
  fileType: string,
  accepted: readonly string[],
): boolean {
  return accepted.includes(fileType);
}
